let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e5buu")).then(() => parcelRequire('bTw5r'));